import _ from "lodash";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
import * as queries from '@/graphql/queries';
import * as queries_custom from '@/graphql/queries_custom';
import * as mutations from '@/graphql/mutations';
import searchConfig from '@/searchConfig';
import * as subscriptions from '@/graphql/subscriptions';
import aws_exports from "../aws-exports";
import gql from "graphql-tag";
const AWS = require('aws-sdk');

export default {
  props: {
    list: {
      type: Object,
      required: true
    },
    onlyShowListIf: {
      type: Boolean,
      default: null
    },
    filter: {
      type: [Array, Object],
    },
    // pass raw filters - used to pass arguments to graphlql calls 
    rawFilter: {
      type: Object,
    },
    exclude: {
      type: Object
    },
    params: {
      type: Object
    },
    relateRecordInput: {
      type: Object
    },
    relateParamsId: {
      type: String
    },
    relateRecordInputField: {
      type: String
    },
    relateRecordInputRole: {
      type: String
    },
    relateRecordInputParentId: {
      type: String
    },
  },
  components: {
    Pagination
  },
  // directives: {
  //   dynamicListTable: {
  //     // directive definition
  //     componentUpdated: function (el) {
  //       console.log('table had been updated!', el);
  //     }
  //   }
  // },
  data() {
    return {
      allItems: [],
      searchError: false,
      searchErrorMessage: '',
      searchQuery: '',
      searchTimeout: null,
      searchConfig: searchConfig,
      isPromisePending: false,
      currentPerPage: 10,
      currentSort: '',
      currentSortDir: '',
      data: {
        default: {items: [], total: 0, curPage: 1, nextToken: 0},
        matches: {items: [], total: 0, curPage: 1, nextToken: 0},
      },
      addonFilters: [],
      isAddonFiltersInitialized: false,
      mdAlertTitle: "",
      mdAlertMessage: "",
      mdAlertDialogShow: false,
      lastOperation: null,
      lastSortByKey: "createdAt",
      lastSortByOrder: "desc",
      selectedCaseLinkReason: "",
      offlineSearchQuery: '',
      offlineSearchData: [],
      isLoadMore: false,
    };
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      this.data.matches.items = [];
      this.data.matches.total = 0;
      this.data.matches.nextToken = null;
      this.data.matches.curPage = 1;
      this.data.default.items = [];
      this.data.default.curPage = 1;
      this.data.default.total = 0;
      this.data.default.nextToken = null;
      this.search(this.searchQuery)
      
    },
    'currentPage' (newValue, oldValue) {
      // if (newValue === oldValue) return;

      // if (newValue > oldValue) {
      //   // determine if we need to search for more rows
      //   let data = this.getData();
      //   let curRecCount = data.items.length;
      //   let numShouldHave = data.curPage * this.currentPerPage;
      //   if (numShouldHave > data.total) numShouldHave = data.total;
      //   if (curRecCount < numShouldHave) {
      //     this.$c.log('retreiving more record');
      //     this.search(this.searchQuery);
      //   }
      // }
    },
    'currentPerPage' (newValue, oldValue) {
      if (newValue === oldValue) return;

      //first, reset values to restart pagination
      let mode = this.searchQuery ? 'matches' : 'default';
      this.data[mode].curPage = 1;
      this.data[mode].items = [];
      this.data[mode].nextToken = null;
      this.isLoadMore = false;

      // determine if we need to search for more rows
      // let data = this.data[mode];
      // let curRecCount = data.items.length;
      // let numShouldHave = data.curPage * this.currentPerPage;
      // if (numShouldHave > data.total) numShouldHave = data.total;
      // if (curRecCount < numShouldHave) {
      //   this.$c.log('retreiving more record');
      //   this.search(this.searchQuery);
      // }

      this.search(this.searchQuery);
    },
    'currentSort' (newValue, oldValue) {
      if (newValue === oldValue) return;
      if (oldValue === '') return; // skip the first update from list defaults

      //first, reset values to restart pagination
      let mode = this.searchQuery ? 'matches' : 'default';
      this.data[mode].curPage = 1;
      this.data[mode].items = [];
      this.data[mode].nextToken = null;
      this.search(this.searchQuery);
    },
    'currentSortDir' (newValue, oldValue) {
      if (newValue === oldValue) return;
      if (oldValue === '') return; // skip the first update from list defaults

      //first, reset values to restart pagination
      let mode = this.searchQuery ? 'matches' : 'default';
      this.data[mode].curPage = 1;
      this.data[mode].items = [];
      this.data[mode].nextToken = null;
      this.search(this.searchQuery);
    },
    'list.defaults.perPage': function() {
      this.refreshDefaults();
      this.search(this.searchQuery);
    },
    /**
     * ATLAS-1007: <Case> <Link Cases> Add ability to link Cases to other Cases
     * 
     * Add selected case link reason to the list
     */
    'selectedCaseLinkReason': {
      immediate: true,
      handler: function() {
        if(this.selectedCaseLinkReason) {
          this.list.CaseLinkReason = this.selectedCaseLinkReason;
          this.mdAlertDialogShow = false;
        }
      }
    },
    'offlineSearchQuery': {
      immediate: true,
      handler: function() {
        this.onOfflineSearch();
      }
    }
  },
  computed: {
    dataNeedsUpdate: function () {
      return this.list.refreshData;
    },
    // Just using this for Vue console debugging
    activeDataName() {
      return this.searchQuery ? 'matches' : 'default';
    },

    /***
     * Returns the appropriate data object
     */
    activeData() {
      return this.searchQuery ? this.data.matches : this.data.default;
    },

    currentPage() {
      return this.activeData.curPage
    },

    // currentPerPage: {
    //   get: () => {
    //     if (!this) return;
    //     let mode = this.searchQuery ? 'matches' : 'default';
    //     return this.data[mode].perPage
    //   },
    //   set: (val) => {
    //     let mode = this.searchQuery ? 'matches' : 'default';
    //     this.data[mode].perPage = val;
    //   }
    // },

    // currentSort() {
    //   return this.activeData.sort
    // },
    //
    // currentSortDir() {
    //   return this.activeData.sortDir
    // },

    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.getData().items;
      return result.length? result.slice(this.from, this.to) : [];
    },

    /***
     * Returns the ending record index used for pagination
     */
    to() {
      return this.from + this.currentPerPage;
    },

    /***
     * Returns the starting record index used for pagination
     */
    from() {
      return this.currentPerPage * (this.getData().curPage - 1);
    },

    totalPages() {
      const data = this.getData();
      return Math.ceil(data.items.length / this.currentPerPage);
    },

    /**
     * Get list of addon filters which are active - a filter is active if it
     * has a value
     */
    activeAddonFilters() {
      return this.addonFilters.filter(_filter => {
        return (
          _filter.value && _filter.value.trim().length &&
          _filter.modal && _filter.modal.trim().length
        );
      });
    }
  },
  methods: {
    getLinkConfig(column, name) {
      return this.list.linkConfigs.find(_column => _column.name == name);
    },
    callLinkHrefCallback(column, name, item) {
      const config = this.getLinkConfig(column, name);
      if (config && 'function' == typeof config.hrefCallback) {
        return config.hrefCallback(column, name, item);
      }
    },
    callLinkTitleCallback(column, name, item) {
      const config = this.getLinkConfig(column, name);
      if (config && 'function' == typeof config.titleCallback) {
        return config.titleCallback(column, name, item);
      }
    },
    refreshDefaults() {
      if (typeof this.list.defaults !== 'undefined') {
        if (typeof this.list.defaults.sort !== 'undefined') {
          this.currentSort = this.list.defaults.sort;
        }
        if (typeof this.list.defaults.sortDir !== 'undefined') {
          this.currentSortDir = this.list.defaults.sortDir;
        }
        if (typeof this.list.defaults.perPage !== 'undefined') {
          this.currentPerPage = this.list.defaults.perPage;
        }
      }
    },
    /**
     * Search table data offline using Fuse.js
     * @see https://fusejs.io/api/options.html#fuzzy-matching-options
     * @return {Array}
     */
    offlineSearch() {
      if (!this.offlineSearchQuery || !this.offlineSearchQuery.trim().length) {
        return this.offlineSearchData;
      }

      const sortableColumnKeys = Object.keys(this.list.columns);
      if (!sortableColumnKeys || !sortableColumnKeys.length) {
        return this.offlineSearchData;
      }

      // create new Fuse instance
      const fuse = new Fuse(this.offlineSearchData, {
        keys: sortableColumnKeys,
        threshold: 0.1
      });
      
      // search data
      return fuse.search(this.offlineSearchQuery);
    },
    onOfflineSearch() {
      const result = this.offlineSearch();
      let listName = this.searchQuery ? 'matches' : 'default';

      this.data[listName].items = result;
      this.data[listName].total = result.length;
    },
    callItemAction(funcName, item) {
      if (typeof this[funcName] === 'function') {
        return this[funcName](item);
      }
    },
    async refresh() {
      this.$c.log('refresh has been called')
      const dataObj = this.getData();
      dataObj.items = [];
      dataObj.curPage = 1;
      dataObj.nextToken = null;
      const result = await this.search(this.searchQuery);
      this.list.refreshData = false;
    },
    getData() {
      return this.searchQuery ? this.data.matches : this.data.default
    },
    getNestedValue(data, nested) {
      let result = '';
      if (typeof nested === 'object') {
        nested.forEach((value) => {
          result += ( (data && data[value])? (data[value] + ' ') : ' ');
        });
      } else {
        if(data !== null) {
          result = data[nested];
        }
      }
      return result;
    },
    getColumnDisplayValue(column, item, name) {
      let result = '';
      if (typeof column === 'undefined' || typeof item === 'undefined' || typeof name === 'undefined') return result;

      if (column.esNested) {
        let esData = JSON.parse(item.esData);

        result = this.$reduce(esData, name.replace('esData.', ''));

        if (typeof column.nested !== 'undefined') {
          result = this.getNestedValue(result, column.nested);
        }
        
        if (column.isAddress) {
          try {
            let address = this.$format.JsonAddressToString(result);
            address = address.replace(/US_|CA_|_/g, ' ').trim();
            result = address;
          } catch {
            // 
          }
        }

      } else {
        if (typeof item[name] === 'undefined') return result;

        if (typeof column.nested !== 'undefined') {
          result = this.getNestedValue(item[name], column.nested);

        } else if(column.optionType=='enum' && item[name]){
          result = item[name].replace(/_/g, ' ');
        }
        else {
          result = item[name];
        }
      }

      if(result === null){        
        result = '';
      }
           
      return result;
    },
    getSearchConfig() {
      const listQueryId = this.list.listQueryId;
      let objectName = listQueryId.substring(0, listQueryId.length - 1).replace('search', '');
      console.log('>>>getSearchConfig objectName = ' + objectName);
      return this.searchConfig[objectName];
    },

    /***
     * Used by the search function
     * Search String should be passed from the function so we can guarantee it includes only those characters passed when search was executed
     * @param searchString
     * @return array
     */
    generateFilters(searchString) {
      let filters = [];
      let addonFilterArr = [];
      
      //list.mustNotFilter is added in case of global search to exclude any field value specifically
      if (!this.activeAddonFilters.length && !this.list.mustNotFilter) {
        if (typeof searchString === 'undefined' || searchString === '') {
          return null;
        }
      }

      // when elastic search is disabled - the graphql query format is different
      const isElasticSearchDisabled = this.list.isElasticSearchDisabled;

      const listQueryId = this.list.listQueryId;

      /* TODO: This could come from this list config... */
      const searchMethod = listQueryId.substring(0, 6) === 'search'? 'term' : 'contains';

      // let objectName = listQueryId.substring(0, listQueryId.length - 1).replace('search', '');

      let searches = [];
      
      if (searchString && searchString.trim().length) {
        if (true === isElasticSearchDisabled) {
          // list query filters are case sensitive - skip lowercase conversion
          searchString = searchString.trim().replace(/[^a-zA-Z0-9 ]/g, '');
        } else {
          searchString = searchString.toLowerCase().trim().replace(/[^a-zA-Z0-9 ]/g, '');
        }
        searches = searchString.split(" ");
  
        this.$c.log('searches', searches);
  
        this.getSearchConfig().searchFields.forEach(searchField => {
          let test, sf = searchField;
  
          if (searches.length === 1) {
            // test = {'term': {}};
            // //test['term'] = {};//{contains: searchString};
            // test['term'][sf] = searchString;//'*' + searchString + '*';
            // filters.push(test);
  
            if (true === isElasticSearchDisabled) {
              test = {};
              test[sf] = { contains: searchString };
            } else {
              test = {'query_string': {'default_field': sf, 'query': '*' + searchString + '*'}};
            }
            filters.push(test);
          } else {
            // test = {'matchPhrase': {}};
            // //test['term'] = {};//{contains: searchString};
            // test['matchPhrase'][sf] = searchString;//'*' + searchString + '*';
            // filters.push(test);
  
            // test = {'query_string': {'default_field': sf, 'query': '*' + searchString + '*'}};
            // filters.push(test);
          }
  
          if (searches.length > 1) {
  
            searches.forEach(term => {
              // test = {};
              // test['term'] = {};//{contains: searchString};
              // test['term'][sf] = term;//'*' + searchString + '*';
              // filters.push(test);
  
              //queryString += '*' + term + '* ';
              test = {'query_string': {'default_field': sf, 'query': '*' + term + '*'}};
              filters.push(test);
            });
  
            //test = {'query_string': {'default_field': sf, 'query': queryString.trim()}};
            //filters.push(test);
          }
  
        });
      }
      
      this.activeAddonFilters.map(_filter => {
        if (true === isElasticSearchDisabled) {
          filters.push({ [_filter.id]: { eq: _filter.modal }});
        } else {
          /**  ATLAS-1047 
          *<Case List> <Search> After applying filter, Search is fetching results from all available cases
          */
          addonFilterArr.push({ match: { [_filter.id]: _filter.modal } })
        }
      });

      //list.mustNotFilter is added to exclude that field value on global filter
      if (!filters.must_not && this.list.mustNotFilter) {
        filters.must_not = this.list.mustNotFilter;
      }

      let result = {"bool": {"should": filters, "minimum_should_match": searches.length }};
      if (true === isElasticSearchDisabled) {
        result = filters;
      }

      /**  ATLAS-1047 
      *<Case List> <Search> After applying filter, Search is fetching results from all available cases
      */
      if (addonFilterArr.length) {
        result.bool.must = addonFilterArr;
      }

      if (typeof this.filter !== 'undefined') {
        result.bool.filter = this.filter;
      }

      if (typeof this.exclude !== 'undefined' && this.exclude !== null) {
        result.bool.must_not = this.exclude.must_not;
      }

      return result;
    },

    /**
     * Load next set of results
     * enable isLoadMore flag to reflect next page load
     * @returns {Void}
     */
    loadMore() {
      const dataObj = this.getData();
      this.isLoadMore = true;
      this.search(this.searchQuery);
    },

    async search(searchString) {
      this.$c.log("search(" + searchString + ")");

      /* TODO: This could come from this list config... */
      const listQueryId = this.list.listQueryId;
      const searchMethod = listQueryId.substring(0, 6) === 'search'? 'search' : 'list';

      if (searchMethod === 'search') {
        let nextToken = 0;
        let dataObj = this.getData();
      }

      let params = {
        limit: this.currentPerPage,
      };

      const nextToken = this.getData().nextToken;
      if (nextToken) {
        params.nextToken = nextToken;
      }

      if (this.currentSort && this.currentSortDir) {
        params.sort = {
          'field': this.currentSort,
          'direction': this.currentSortDir
        };

        if (['id', 'description', 'name','given_name', 'family_name', 'email', 'phone', 'priority', 'nameLegal', 'namePrevious', 'merchantNumber', 'category', 'legacyName', 'brand', 'subject', 'status', 'type', 'cognito_groupid', 'dateDue', 'quickNote', 'ssn', 'phone_mobile','phone_number','body','level', 'change'].indexOf(this.currentSort) !== -1) {
          params.sort.keyword = true;
        }
      }

      if (params.sort.field && this.list.ignoreSortColumns) {
        if (-1 != this.list.ignoreSortColumns.indexOf(params.sort.field)) {
          delete(params.sort);
        }
      }

      if (true === this.list.addDefaultSortIfNone) {
        if (!params.sort || !params.sort.field) {
          params.sort = {
            'field': 'createdAt',
            'direction': 'desc'
          };
        }
      }

      let filters = this.generateFilters(searchString);
      this.$c.log("search(" + searchString + ") filters: ", filters);

      // if (typeof this.filter !== 'undefined') {
      //   if (filters.length > 1) {
      //     params.filter = {and: [
      //         this.filter,
      //         {or: filters}
      //       ]};
      //   } else if (filters.length === 1) {
      //     params.filter ={and: [
      //         this.filter,
      //         filters[0]
      //       ]};
      //   } else {
      //     params.filter = this.filter;
      //   }
      // } else {
      //   if (filters.length > 1) {
      //     params.filter = {or: filters};
      //   } else if (filters.length === 1) {
      //     params.filter = filters[0];
      //   }
      // }
      if (filters !== null) {
        
        // Replacing space of status filter text with underscore
        if (filters.bool && filters.bool.should) {
          filters.bool.should.forEach(item => {
            if (item.query_string && item.query_string.default_field && item.query_string.default_field === "status") {
              item.query_string.query = item.query_string.query.replace(/ /g,'_');
            }
          })
        }
        
        console.log("Updated Filters", filters);

        if (typeof this.filter !== 'undefined') {
          filters.bool.filter = this.filter;
        }
        if (true === this.list.isElasticSearchDisabled) {
          params = Object.assign({}, params, { filter: this.getDynamoDbFilterMap(filters) });
        } else {          
          params.filter = {esQuery: JSON.stringify(filters)};
        }
      }
      else if (typeof this.filter !== 'undefined' && typeof this.exclude !== 'undefined' && this.exclude) {
        params.filter = {esQuery: JSON.stringify({"bool": {"filter": this.filter, "must_not": this.exclude.must_not}})};
      }
      else if (typeof this.filter !== 'undefined') {
        params.filter = {esQuery: JSON.stringify({"bool": {"filter": this.filter}})};
      }
      else if (typeof this.exclude !== 'undefined' && this.exclude) {
        params.filter = {esQuery: JSON.stringify({"bool": {"must_not": this.exclude.must_not}})};
      }

      // pass raw filter to GraphQL - this can be used to pass custom arguments
      if (this.rawFilter) {
        params = Object.assign({}, params, this.rawFilter);
      }

      if (typeof this.params !== 'undefined') {
        this.$loopo(this.params, (param, paramName) => {
          params[paramName] = param;
        });
      }
      this.$c.log("search(" + searchString + ") params: ", params);

      //Get the correct query
      //const listQueryId = this.list.listQueryId;
      let query = queries[listQueryId];
      if (typeof query === 'undefined') {
        query = queries_custom[listQueryId];
      }


      let operation = this.lastOperation = graphqlOperation(query, params);

      this.$c.log(listQueryId + " operation: ", operation);

      this.isPromisePending = true;

      //const result = await API.graphql(operation);
      //this.handleSearchResponse(result);

      // ATLAS-171 - uncommented the graphql api handling error
      API.graphql(operation)
        .then(response => {
          if (typeof response.errors === 'undefined' && this.lastOperation == operation) {
            this.handleSearchResponse(response);
          }
          this.isPromisePending = false;
        })
        .catch(response => {
          if (typeof response.errors !== 'undefined' && response.errors.length) {
            this.$c.log(response);
            let skipError = "Elasticsearch responded with an error: Not Found";
            let errorMsg = response.errors[0].message;

            // if (this.getErrorReponseData(response)) {
            //   this.handleSearchResponse(response)
            //   this.isPromisePending = false
            //   return
            // }

            /**
             * ATLAS-681 ElasticSearch error - no results
             * Show alert dialog
             * 
             * ATLAS-793 Getting Error Screen when no data found
             * Hide alert dialog
             */
            if (errorMsg && !errorMsg.includes(skipError)) {
              this.mdAlertTitle = "Error!!";
              this.mdAlertMessage = "Search Error, reload the page";
              this.mdAlertDialogShow = true;
            }
      
            let listName = this.searchQuery ? 'matches' : 'default';
            this.data[listName].items = [];
            this.data[listName].total = 0;
            this.isPromisePending = false;
          }
        });
    },
    
    /**
     * ATLAS-1238 - <DM><Report><Conversion Bonuses> Search Portfolio is not working
     * 
     * @description
     * inside errors object look for paths with errors
     * exclude all items with errors and if any valid data is found then return it
     * 
     * @see
     * https://zeamster.atlassian.net/browse/ATLAS-1238
     * 
     * @param {Object} Response
     * @returns {Mixed} void on error - array of valid item objects on success
     */
    getErrorReponseData(response) {
      // response field name
      const responseFieldName = this.list.responseFieldName? this.list.responseFieldName : this.list.listQueryId;
      
      // look for items - if none foudn then bail
      let items = this.$reduce(response, `data.${responseFieldName}.items`)
      if (!items || !items.length) {
        return
      }
      
      // if error items are not found then bail
      if (!response.errors || !response.errors.length) {
        return;
      }
      
      // find all invalid item indexes - this can be found inside the path prop
      let invalidItemIndexes = []
      for (const _error of response.errors) {
        const invalidIndex = this.$reduce(_error, 'path.2')
        if ('number' === typeof invalidIndex) {
          invalidItemIndexes.push(invalidIndex)
        }
      }
      
      // sort invalid indexes in descending order and remove all invalid items
      invalidItemIndexes = invalidItemIndexes.sort().reverse()
      for (const _index of invalidItemIndexes) {
        items.splice(_index, 1)
      }
      
      // no valid data found - bail
      if (!items.length) {
        return
      }
      
      // update total field to make sure we don't cause accidental refresh
      response.data[responseFieldName].total = items.length
      
      return items
    },

    handleSearchResponse(result) {

      console.log("Search Service Response ==>", result);
      if (typeof this.list.filterResponse === 'function') {
        result = this.list.filterResponse(result);
      }

      this.searchError = false;
      this.searchErrorMessage = '';

      const listQueryId = this.list.listQueryId;
      const responseFieldName = this.list.responseFieldName? this.list.responseFieldName : listQueryId;
      const searchMethod = listQueryId.substring(0, 6) === 'search'? 'search' : 'list';
      this.$c.log(listQueryId + " Results Raw:", result.data);

      let response = false;

      if (!this.isAddonFiltersInitialized) {
        this.initAddonFilters(result);
        this.isAddonFiltersInitialized = true;
        /**  with new pagination, records get set without addon filter first and again add records with addon filter, 
         * so getting duplicate records. To avoid this need to return
        */
        if(this.activeAddonFilters && this.activeAddonFilters.length){
          return
        }
      }

      if (typeof this.list.formatResponse === 'function') {
        // result.data[responseFieldName].items.forEach((_item) => {
        //   this.$loopo(_item, (value, key) => {
        //     if (_item[key] === null) {
        //       _item[key] = '';
        //     }
        //   })
        // });
        
        response = this.list.formatResponse(result.data);
      } else {
        if (result.data && result.data[responseFieldName] && result.data[responseFieldName].items) {
          response = result.data[responseFieldName].items;
        }
      }

      // store data for offline search
      this.offlineSearchData = response;

      /**
       * ATLAS-440: Fix for dateDue sorting issue
       * dateDueOrig field has ISO string formatted values
       */
      if(this.currentSort && this.currentSort == 'dateDue' && this.list.defaults.customFieldSort) {
        let sortedItmes = _.sortBy(response, 'dateDueOrig');
        if ('desc' == this.currentSortDir) {
          response = sortedItmes.reverse();
        } else {
          response = sortedItmes;
        }
      }

      this.$c.log(listQueryId + " Results Formatted:", response);

      if (true === this.list.isOfflineSearchEnabled) {
        response = this.offlineSearch();
      }

      let listName = this.searchQuery ? 'matches' : 'default';
      if (this.list.defaults.itemsToLoad) {
        this.allItems = response;
        this.data[listName].items =  this.allItems.slice(0, this.list.defaults.perPage);
      } else {
        this.data[listName].items =  [...this.data[listName].items, ...response];
      }
      if (searchMethod === 'search') {
        //update showing total results count on dialog
        //if (typeof this.list.linkActive !== 'undefined' && (this.list.linkActive == true))
        if ((typeof this.list.linkActive !== 'undefined' && (this.list.linkActive == true)) || this.list.activeFlag == true)
          this.data[listName].total = response.length;
        else
          this.data[listName].total = result.data[responseFieldName].total;
      } else {
        this.data[listName].total = this.data[listName].items.length;
      }

      if (true === this.list.isOfflineSearchEnabled) {
        this.onOfflineSearch();
      }

      const dataObj = this.getData();
      
      // if next page load is requested and more items are available
      // then increment current page
      if (this.isLoadMore && result.data[responseFieldName].items.length) {
        dataObj.curPage += 1;
        this.isLoadMore = false;
      }
      
      // if number of items returned is equal to the current page limit
      // then set nextToken
      if (result.data[responseFieldName] && result.data[responseFieldName].items.length === this.currentPerPage) {
        dataObj.nextToken = this.currentPerPage * dataObj.curPage;
      } else {
        dataObj.nextToken = null;
      }

      return response;
    },

    deleteSyncRecord(item, listdeleteRelatedRecord) {
      this.$loopo(listdeleteRelatedRecord, (recordValue, recordKey) => { 
        let promiseArr = [];
        let stepsArr = item[recordValue.relatedModelItem].items;

        this.$loopo(stepsArr, (value, key) => {   
          console.log(recordValue.relatedModelItem, ' id ',value.id)
          let loopRecord = [];
          if(( typeof recordValue.record !== 'undefined' )){
            loopRecord = recordValue.record;  
          } 
          promiseArr.push(this.deleteRelatedRecords(value, recordValue.deleteSyncQueryId, loopRecord ));        
        });

        Promise.allSettled(promiseArr).then((resultPromise) => {
            console.log('Deleted related record successfully....')
        }).catch(error => {
          this.$c.log("Delete related record error ", error);
        });  
        
      });
    },

    deleteRelatedRecords(value, deleteSyncQueryId, loopRecord) {
      let id = value.id;
      let gqlRequest = graphqlOperation(mutations[deleteSyncQueryId], {input: {"id": id}});
      this.$c.log('gqlRequest delete------------------', gqlRequest);
      let responcePromise = API.graphql(gqlRequest).then( response => {
        if(loopRecord.length) {
          this.deleteSyncRecord(response.data[deleteSyncQueryId], loopRecord);
        }
      });
      return responcePromise;
    },

    async delete(item) {
      let idField = 'id';
      if (typeof this.list.deleteQueryIdField !== 'undefined') {
        idField = this.list.deleteQueryIdField;
      }
      if(this.list.deleteQueryId == 'deleteTeam') {
        if (item[this.list.deleteGroupId] != null) {
          let groupIdField = item[this.list.deleteGroupId].replace(/\s+/g, '_');
          console.log('group name to delete: ', groupIdField);
          var params = {
            GroupName: groupIdField, /* required */
            UserPoolId: aws_exports.aws_user_pools_id, /* required */
          };

          Promise.resolve(Auth.currentAuthenticatedUser())
            .then(user =>
              Auth.currentCredentials()
                  .then(credentials =>
                    Promise.resolve(
                      new AWS.CognitoIdentityServiceProvider({
                        apiVersion: '2016-04-18',
                        credentials: Auth.essentialCredentials(credentials),
                        region: aws_exports.aws_appsync_region
                      })
                    )
                  )
                  .then(client => {
                    var responceGroupData = client.deleteGroup(params).promise();
                    console.log('Responce of delete group', responceGroupData);
                  })
            )
        }
      }

      if(this.list.deleteSyncQueryId) {
        this.deleteSyncRecord(item);
      }

      if(this.list.disassociateRelatedRecord) {
        let updatePromiseArr = [];
        this.list.disassociateRelatedRecord.record.forEach((_itemElem) => {
          item[_itemElem.relatedModelItem].items.forEach((_item) => {
            let updateData = {
              'id' : _item.id
            };
            updateData[_itemElem.updateFieldId] = null;
            console.log(updateData);
            let gqlRequest = API.graphql(graphqlOperation(mutations[_itemElem.updateQueryId], {input: updateData}));
            updatePromiseArr.push(gqlRequest);
          });
        });
        Promise.allSettled(updatePromiseArr).then(async (resultPromise) => {
          this.$c.log('Tasks  disassociated Successfully');
          this.$c.log(this.list.pageTitle + " deleting record:", item[idField]);
          this.deleteRecord(item,idField);
        });
      
      } else if(this.list.disassociateRecord){
          let updateData = {
            'id' : item.id
          };
          updateData[this.list.disassociateRecord.updateFieldId] = null;
          console.log(updateData);

          await API.graphql(graphqlOperation(mutations[this.list.disassociateRecord.updateQueryId], {input: updateData}))
          .then( response => {
            this.afterDelete(item)})
          .catch(error => {
            this.$c.log(this.list.pageTitle + " delete record error:", error);
          });


      } else {
        this.$c.log(this.list.pageTitle + " deleting record:", item[idField]);
        this.deleteRecord(item,idField);
      }
    },
    async deleteRecord(item,idField) {
      await API.graphql(graphqlOperation(mutations[this.list.deleteQueryId], {input: {"id": item[idField]}}))
      .then( response => {
        if(( typeof this.list.deleteRelatedRecord !== 'undefined' )){
          this.deleteSyncRecord(response.data[this.list.deleteQueryId], this.list.deleteRelatedRecord.record);
        }
        this.afterDelete(item)})
      .catch(error => {
        this.$c.log(this.list.pageTitle + " delete record error:", error);
      });
    },
    afterDelete(item) {
      let nameFields = this.list.deleteMessageNameFields ? this.list.deleteMessageNameFields : ['name'];
      let objectName = '';
      nameFields.forEach((nf, index) => {
        objectName += item[nf];
        if (index !== nameFields.length -1) objectName += ' ';
      });
      
      this.$c.log(this.list.pageTitle + " delete record success!");
      this.deleteRow(item);
      Swal.fire({
        title: "Deleted!",
        text: `You deleted ${objectName}`,
        type: "success",
        confirmButtonClass: "md-button md-success btn-fill",
        buttonsStyling: false
      });
    },
    newRecord() {
      if (typeof this.list.showRelatedDialog !== 'undefined') {
        this.list.showRelatedDialog = true;
        return;
      }

      if (typeof this.filter === 'undefined' || this.filter === null) {
        this.$router.push("/" + this.list.editPath + '/new');
      } else {
        let isFound = false;
        if (this.filter !== null && !this.filter.match) {
          this.$loopo(this.filter,
            (item, name) => {
              /**
               * ATLAS-522: Add Product from Account
               * Set redirection for match query
               */
              if(item.match) {
                let objKey, objValue = '';
                for (let [key, value] of Object.entries(item.match)) {
                  objKey = key;
                  objValue = value;
                }
                this.$router.push("/" + this.list.editPath + '/new?' + objKey + '=' + objValue);
              } else {
                this.$router.push("/" + this.list.editPath + '/new?' + name + '=' + item.eq);
              }
              isFound = true;
          });
        } else {
          this.$loopo(this.filter.match,
            (item, name) => {
              this.$router.push("/" + this.list.editPath + '/new?' + name.replace('.keyword','') + '=' + item);
              isFound = true;
            });
        }
        if (!isFound && this.list.editPath) {
          this.$router.push("/" + this.list.editPath + '/new');
        }
      }
    },
    /**
     * Add New Button on ElasticList
     */
    addNewRecord() {
      if (typeof this.list.showAddNewModal !== 'undefined') {
        this.list.showAddNewModal = true;
        return;
      }

      if (typeof this.filter === 'undefined') {
        this.$router.push("/" + this.list.editPath + '/new');
      } else {
        this.$loopo(this.filter, (item, name) => {
          this.$router.push("/" + this.list.editPath + '/new?' + name + '=' + item.eq);
        });
      }
    },
    customSort(value) {
      // leave this empty function here so it can prevent the default code from running inside md-table

      // console.log('inside customSort value:', value)
      // return value.sort((a, b) => {
      //   console.log('inside customSort value.sort a:', a)
      //   console.log('inside customSort value.sort b:', b)
      //   const sortBy = this.list.currentSort;
      //   let aSortBy = typeof a[sortBy] !== "undefined" && a[sortBy] !== null? a[sortBy] : "";
      //   let bSortBy = typeof b[sortBy] !== "undefined" && b[sortBy] !== null? b[sortBy] : "";
      //   if (this.list.currentSortOrder === "desc") {
      //     return aSortBy.localeCompare(bSortBy);
      //   }
      //   return bSortBy.localeCompare(aSortBy);
      // });
    },
    /**
     * ATLAS-841: Products list columns need to be updated
     * 
     * Sorting table data manually in Colapsible List
     */
    onSort(key) {
      let result = this.getData().items;
      let lastSortKey = this.lastSortByKey
      this.lastSortByKey = key;
      let currentSortBy = "asc";
      if (lastSortKey === key) {
        if (this.lastSortByOrder === "asc") {
          currentSortBy = "desc";
        }else {
          currentSortBy = "asc";
        }
      }
      const sortBy = key;
      this.lastSortByOrder = currentSortBy;
      return result.sort((a, b) => {
        let aSortBy = String(typeof a[sortBy] !== "undefined" && a[sortBy] !== null? a[sortBy] : "");
        let bSortBy = String(typeof b[sortBy] !== "undefined" && b[sortBy] !== null? b[sortBy] : "");
        if (currentSortBy === "desc") {
          return bSortBy.localeCompare(aSortBy);
        }
        return aSortBy.localeCompare(bSortBy);
      });
    },
    handleEdit(item) {
      this.$router.push({ path: "/" + this.list.editPath + "/" + item.id});
    },
    handleRedirectNested(item) {
      let redirectId = item[this.list.redirectNested.parentPathId];
      if(this.list.redirectNested.parentPathId.indexOf('.') !== -1) {
        redirectId = item;
        let keyArr =  this.list.redirectNested.parentPathId.split('.');
        for(let i=0; i< keyArr.length; i++) 
          redirectId = redirectId[keyArr[i]];
      }
      this.$router.push({ path: "/" + this.list.redirectNested.parentPath + "/" + redirectId + "/" + this.list.redirectNested.path + "#" + item.id});
    },

    /**
     * ATLAS-920 Add fields from "Create People"that may be different in on Services to the PersonAccount modal dialogue + schema modal.
     * Methods to set showPopupModal and add selected item to list
     * Added afterAdd method to the list and calling this method from popup modal
     */
    async showPopupModal(item) {
      this.list.showPopupModal = true;
      this.list.createNew = false;
      this.list.selectedItem = item
      this.list.afterAdd = this.afterAdd
    },
    async handleAddRole(item) {
        Swal.fire({
          title: 'Select the Role',
          input: 'select',
          inputOptions: this.list.roleRecord,
          //inputPlaceholder: 'required',
          showCancelButton: true,
          inputValidator: function (value) {
            return new Promise(function (resolve, reject) {
              if (value !== '') {
                resolve();
              } else {
                reject('You need to select a Role');
              }
            });
          }
        }).then((role) => {
          if (role.value) {
            this.isPromisePending = true;
            
            if(this.list.listQueryId == "searchUsers"){
              this.getModelData(this.$route.params.id, 'searchTeams').then(getRes => {
                
                let cognitoGroupId = getRes.searchTeams.items[0].cognito_groupid;
                
                this.addTeamUSer(item, item.email, role.value, cognitoGroupId, item.cogUsername)
              });
            }else if(this.list.listQueryId == "searchTeams"){              
              this.getModelData(this.$route.params.id, 'searchUsers').then(getRes => {                
                let userEmail = getRes.searchUsers.items[0].email;
                let cogUserId = getRes.searchUsers.items[0].cogUsername;
                
                this.addTeamUSer(item, userEmail, role.value, item.cognito_groupid, cogUserId)
              });
            }else {
              let input = this.relateRecordInput;
              input[this.relateRecordInputField] = item.id;
              input[this.relateRecordInputRole] = role.value;
        
              API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: input}))
                .then(this.afterAdd(item))
                .catch(error => {
                  this.$c.log(this.list.pageTitle + " adding record error:", error);
                });                        
            }
          }else{
            console.log('cancel button add');
          }
        })
    },
    async getModelData (Id, queryId) {
      let params = {}, operation, response = [];
      params.filter = {esQuery: JSON.stringify({"match": {"id": Id }})};
      operation = graphqlOperation(queries[queryId], params);
      const result = await API.graphql(operation);
      return result.data;
    },
    async addTeamUSer(item, userEmail, role, groupId, cogUsername) {
      this.$c.log(this.list.pageTitle + " adding record:", item.id);

      let input = this.relateRecordInput;
      input[this.relateRecordInputField] = item.id;
      
      input['role'] = role;
      input['cognito_userid'] = cogUsername;
      input['cognito_groupid'] = groupId;
      
      var params = {
          GroupName: groupId, /* required */
          UserPoolId: aws_exports.aws_user_pools_id, /* required */
          Username: userEmail, 
        };
        console.log('Cognito add team params:', params);
        Promise.resolve(Auth.currentAuthenticatedUser())
          .then(user =>
            Auth.currentCredentials()
                .then(credentials =>
                  Promise.resolve(
                    new AWS.CognitoIdentityServiceProvider({
                      apiVersion: '2016-04-18',
                      credentials: Auth.essentialCredentials(credentials),
                      region: aws_exports.aws_appsync_region
                    })
                  )
                )
                .then(client => {
                  var responceGroupData = client.adminAddUserToGroup(params).promise();
                  console.log('Responce add user to Group', responceGroupData);
                })
                .catch(err => {
                  console.log('Error to delete user from Group', err);
                })
        )

      await API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: input}))
        .then(this.afterAdd(item))
        .catch(error => {
          this.$c.log(this.list.pageTitle + " adding record error:", error);
        });
    },
    /**
     * ATLAS-1007: <Case> <Link Cases> Add ability to link Cases to other Cases
     * @param {*} item 
     */
    async handleCaseLink(item) {
      //validate if reason not selected
      if(!this.selectedCaseLinkReason) {
        this.mdAlertTitle = "Required Validation!!";
        this.mdAlertMessage = "Case Link Reason is not selected.";
        this.mdAlertDialogShow = true;
        return;
      }

      let input = {
        "caseLinkCaseId": this.relateRecordInput.caseId,
        "caseLinkLinkCaseId": item.id,
        "reason": this.selectedCaseLinkReason
      }

      await API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: input}))
        .then(this.afterAdd(item))
        .catch(error => {
          this.$c.log(this.list.pageTitle + " adding record error:", error);
        });
    },
    /**
     * handleAddTask(), addTask() will be used
     * for creating new task from task template
     * @param {*} item 
     */
    handleAddTask(item){
      this.addTask(item);
    },
    async addTask(item) {
      let input = this.relateRecordInput;
      input[this.relateRecordInputField] = item.id;

      let params = {};
      params.filter = {esQuery: JSON.stringify({"match": {"id": input.id }})};
      const opResult = await API.graphql(graphqlOperation(queries_custom["searchTasksSteps"], params));

      if(
        opResult.data && 
        opResult.data.searchTasks && 
        opResult.data.searchTasks.items
      ) {
        const newInput = JSON.parse(JSON.stringify(opResult.data.searchTasks.items[0]));
        const stepsInput = [];
        let promiseArr = [];

        newInput.taskCaseId = input.taskCaseId;
        newInput.group = input.group;
        newInput.order = input.order;
        newInput.isTemplate = false;
        if(newInput.internal === null) {
          newInput.internal = false;
        }
        if(newInput.user){
          newInput.taskUserId = newInput.user.id;
        }

        /**
         * ATLAS-530 Make current user the default assignee when creating
         * a New Task from Case details -> Add Task popup -> From Template
         */
        if(newInput.user === null){
          newInput.taskUserId = this.$Session.userId;
        }

        /**
         * ATLAS-676 Task Form Changes:
         * Set default status if not provided from Task Template
         * 
         * ATLAS-668 Tasks from Task Templates:
         * Set due date to the date that the task is made available
         */
        if(newInput.status === null) {
          newInput.status = "Open";
        }
        if(newInput.dateDue === null) {
          newInput.dateDue = new Date().toUTCString();
        }

        //create task steps data
        if(newInput.steps && newInput.steps.items){
          let stepsItem = newInput.steps.items;
          stepsItem.forEach((_itemElem, _itemIdx) => {
            stepsInput.push(_itemElem);
          });
        }

        //delete not essential keys
        delete newInput.id;
        delete newInput.createdAt;
        delete newInput.steps;
        delete newInput.case;
        delete newInput.user;

        if(newInput){
          await API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: newInput}))
          .then(result => {
            if(stepsInput) {
              stepsInput.forEach((_itemElem) => {
                //ATLAS-815 Default Task Step status - Open
                let inputStepsData = {
                  title: _itemElem.title,
                  description: _itemElem.description,
                  taskStepTaskId: result.data.createTask.id,
                  status: (_itemElem.status === null ? "Open" : _itemElem.status),
                  order: _itemElem.order,
                };
    
                let gqlRequest = API.graphql(graphqlOperation(mutations['createTaskStep'], {input: inputStepsData}));
                promiseArr.push(gqlRequest);
              });

              Promise.allSettled(promiseArr).then((resultPromise) => {
                this.$c.log('Task steps created Successfully');
              });
            }
          })
          .catch(error => {
            this.$c.log(this.list.pageTitle + " adding record error:", error);
          });
        }
      }
    },
    /**
     * ATLAS-1012: <Product Option> <Side Panel> Product Dependencies
     * @param {*} item 
     */
    handleAddParentPO(item) {
      if (item.parentPOName) {
        this.handleAddPOChild(item);
      } else {
        this.add(item);
      }
    },
    /**
     * ATLAS-624 Product Dependencies - part 2 -
     * Require product selection on front end based on dependencies
     * 
     * Show Alert dialog with PO checkbox & save data in ProductOptionProductOption table
     * @param {*} item
     */
    handleAddPOChild(item) {
      Swal.fire({
        title: 'Selected Children: ' + (item.parentPOName ? item.parentPOName : item.name),
        input: 'checkbox',
        inputPlaceholder: 'Is Required?',
        showCancelButton: true
      }).then((result) => {
        //if Cancel button clicked
        if(result && result.dismiss) {
          return;
        }

        let input = this.relateRecordInput;
        //if Required checked
        if (result.value && result.value == 1) {
          input['required'] = true;
        } else {
          delete input.required;
        }
        this.add(item);
      })
    },
    handleAdd(item) {
      this.add(item);
    },
    async add(item) {
      this.$c.log(this.list.pageTitle + " adding record:", item.id);
      let input = this.relateRecordInput;
      input[this.relateRecordInputField] = item.id;

      //ATLAS-1244: On ProductOption Sidepanel - Add Parents and Dependencies
      if (this.relateRecordInputParentId) {
        if (input.productOptionChildChildId) {
          input[this.relateRecordInputParentId] = input.parentId;
        } else {
          input[this.relateRecordInputParentId] = item.id;
        }
      }

      await API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: input}))
        .then(this.afterAdd(item))
        .catch(error => {
          this.$c.log(this.list.pageTitle + " adding record error:", error);
        });
    },
    /**
     * Add the portfolio item to ReportPortfolios model
     * @param {Object} item - the portfolio item
     */
    async handleAddReportPortfolio(item) {
      this.$emit('reportPortfolioAdded', _.cloneDeep(item));
      const input = { reportPortfoliosPortfolioId: item.id };

      if (true === this.list.isPortfolioAddLogDisabled) {
        return this.afterAdd(item);
      }
      
      /**
       * ATLAS-877 - Add Updatedby to all Models in the Schema
       * @see https://zeamster.atlassian.net/browse/ATLAS-877
       */
      input.reportPortfoliosUpdatedById = this.$reduce(this, '$Session.userId');
      
      const mutation = mutations.createReportPortfolios;
      this.$c.log(this.list.pageTitle + " adding ReportPortfolios record:", input);
      await API.graphql(graphqlOperation(mutation, { input }))
        .then(response => {
          this.afterAdd(item);
        })
        .catch(err => {
          this.$c.log(this.list.pageTitle + " adding record err:", err);
        });
    },
    handleLink(item) {
      this.linkAdd(item);
    },
    async linkAdd(item) { 
      this.$c.log(this.list.pageTitle + " adding record:", this.relateParamsId);

      let input = {};
      input['id'] = item.id ;
      input[this.relateRecordInputField] = this.relateParamsId;

      await API.graphql(graphqlOperation(mutations[this.list.updateMutationId], {input: input}))
        .then(this.afterAdd(item))
        .catch(error => {
          this.$c.log(this.list.pageTitle + " adding record error:", error);
        });
    },
    afterAdd(item) {
      this.$c.log(this.list.pageTitle + " add record success!");
      item.added = true;
      this.isPromisePending = false;
      setTimeout(() => {
        this.$emit('relationshipAdded', item);
        //window.bus.$emit('groupRefresh', { groupId: 0, item });
        this.deleteRow(item);
      }, 500);
    },
    handleDelete(item) {
      console.log(item);
      //build the name first
      let nameFields = this.list.deleteMessageNameFields ? this.list.deleteMessageNameFields : ['name'];
      let objectName = '';
      nameFields.forEach((nf, index) => {
        objectName += item[nf];
        if (index !== nameFields.length -1) objectName += ' ';
      });

      // without at least 1 character this will use the default on the right
      let title = this.list.deleteMessageTitle ? this.list.deleteMessageTitle : "Are you sure you want to delete {objectName}?";
      title = title.replace('{objectName}', objectName);

      //this test is different because we want to allow config of '' to omit the default text
      let text = typeof this.list.deleteMessageText !== 'undefined' ? this.list.deleteMessageText : `The change cannot be undone.`;

      Swal.fire({
        title: title,
        text: text,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(item);
        }
      });
    },
    deleteRow(item) {
      this.$emit('deleteRow', item);

      ['default', 'matches'].forEach(dataName => {
        let indexToDelete = this.data[dataName].items.findIndex(
          tableRow => tableRow.id === item.id
        );
        if (indexToDelete >= 0) {
          this.data[dataName].items.splice(indexToDelete, 1);
          this.data[dataName].total--;
        }
      });
    },
    /**
     * Initliaze Addon Filters from GraphQL response
     * @param {GraphQL Response} result 
     */
    initAddonFilters(result) {
      console.log('initAddonFilters----------------------------------', result);
      if (this.list.addonFilters) {
        this.list.addonFilters.forEach((_filter, _index) => {
          // configure options key
          let optionsKey = 'items';
          if (_filter.queryOptionsKey) {
            optionsKey = _filter.queryOptionsKey;
          }
          
          // if filter query does not exist or result data is not available - bail
          if (!_filter.query || !result.data[_filter.query] || !result.data[_filter.query][optionsKey]) {
            return;
          }

          // prepare addon filter options  
          const addonFilter = JSON.parse(JSON.stringify(_filter));
          addonFilter.allOptions = result.data[_filter.query][optionsKey];
          
          // process options - if we have a formater available - the use it to
          // format label options
          const labelKey = this.getAddonFilterLabelKey(addonFilter); 
          addonFilter.allOptions = addonFilter.allOptions.map(_option => {
            if (_filter.labelFormatter && 'function' == typeof _filter.labelFormatter) {
              _option[labelKey] = _filter.labelFormatter(_option).replace(/_/g, ' ');
            } else {
              _option[labelKey] = _option[labelKey].replace(/_/g, ' ');
            }

            return _option;
          });
          
          // if we have a filter callback available - then use it to filter options
          if (_filter.optionsFilter && 'function' == typeof _filter.optionsFilter) {
            addonFilter.allOptions = addonFilter.allOptions.filter(_option => {
              return _filter.optionsFilter(_option);
            });
          }
          
          // add All Option which basically clears the filter
          if (addonFilter.all && addonFilter.all.isEnabled) {
            const showAllOption = {};
            showAllOption[addonFilter.label] = addonFilter.all.label;
            showAllOption[addonFilter.key] = '';
            addonFilter.allOptions.unshift(showAllOption);
          }

          addonFilter.options = new Promise(resolve => resolve(addonFilter.allOptions));
          
          // Add new addon filter or update existing addon filter
          const addonFilterIndex = this.addonFilters.findIndex(_addonFilter => _addonFilter.id == _filter.id);
          if (-1 == addonFilterIndex) {
            this.addonFilters.push(addonFilter);
          } else {
            this.addonFilters[addonFilterIndex] = addonFilter;
          }
          
          // initialize default option
          if (addonFilter.default) {
            const defaultOption = addonFilter.allOptions.find(_option => {
              return _option[addonFilter.default.key] == addonFilter.default.value;
            });
            if (defaultOption) {
              this.onAddonFilterSelect(defaultOption, addonFilter);
            }
          }
        });
      }
    },
    /**
     * Handle addon filter change
     * @param {string} searchTerm 
     * @param {Object} an addon filter
     */
    onAddonFilterChange(searchTerm, filter) {
      this.data.matches.items = [];
      this.data.matches.total = 0;
      this.data.matches.nextToken = null;
      this.data.matches.curPage = 1;
      this.data.default.items = [];
      this.data.default.curPage = 1;
      this.data.default.total = 0;
      this.data.default.nextToken = null; 
      filter.options = new Promise(resolve => {
        let items = filter.allOptions;
        // when search term is missing reset filter and show all options
        if (!searchTerm) {
          filter.value = '';
          filter.modal = '';
          this.search(this.searchQuery);
        } else {
          // find available options
          const labelKey = this.getAddonFilterLabelKey(filter);
          const term = searchTerm && searchTerm.length ? searchTerm.toLowerCase() : searchTerm.toLowerCase();
          items = filter.allOptions.filter(_option => {
            return _option[labelKey] && _option[labelKey].toLowerCase().includes(term);
          });
        }
        resolve(items);
      });
    },
    /**
     * Handle event when an addon filter value is selected from dropdown
     * @param {Object} selected object
     * @param {Object} addon filter object
     */
    onAddonFilterSelect(value, filter) {
      filter.value = value[filter.label];
      filter.modal = value[filter.key];
      if(filter.queryOptionsKey && filter.queryOptionsKey === 'enumValues'){
        filter.modal = filter.modal.replace(/ /g, '_');
      }
      this.data.matches.items = [];
      this.data.matches.total = 0;
      this.data.matches.nextToken = null;
      this.data.matches.curPage = 1;
      this.data.default.items = [];
      this.data.default.curPage = 1;
      this.data.default.total = 0;
      this.data.default.nextToken = null;      
      this.search(this.searchQuery);
    },
    /**
     * Get the label field key - if not defined then use name
     * @param {Object} filter - the filter object
     */
    getAddonFilterLabelKey(filter) {
      return filter.label ? filter.label : 'name';
    },
    /**
     * Convert an array of filters for direct use as filter param
     * in a GraphQL query
     * @param {array} filters array of of filter objects
     * @returns {object} filter map for use with GraphQL
     */
    getDynamoDbFilterMap(filters) {
      let resultFilters = {};
      filters.map(_filter => {
        resultFilters = Object.assign({}, resultFilters, _filter);
      });
      return resultFilters;
    }
  },
  apollo: {
    subscriptions: {
      query: function() {
        return gql(queries['searchUsers']);
      },
      variables: {
        filter: { id: { eq: '-1' } },
        limit: 1,
      },
      update: () => [],
    }
  },
  async mounted() {

    if (this.list.subscriptions) {
      this.$loopo(this.list.subscriptions, (sub, name) => {
        this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);

        if (typeof subscriptions[name] === 'undefined') {
          this.$c.error('SUBSCRIPTION [' + name + '] not found!');
          return;
        }

        let thisFunc = this.list.subscriptions[name].function;
        this.$apollo.queries.subscriptions.subscribeToMore({
          document: gql(subscriptions[name]),
          updateQuery: (previousResult, { subscriptionData }) => {
            console.log('SUBSCRIPTION ', name, subscriptionData);
            thisFunc({ value: subscriptionData });
          },
        });
      });
    }

    if (!this.list.skipMount && (this.onlyShowListIf === null || this.onlyShowListIf)) {
      await this.search();

      if (typeof this.isSearchMessageChange === 'function') { 
        this.isSearchMessageChange(this.$route.hash.substring(1));
      }
    }

    // if (this.list.tableData.length === 0) {
    //   const result = await this.search();
    // this.list.tableData = result;
    // this.$c.log("mounted() this.list.tableData:", this.list.tableData);
    // }

    // Fuse search initialization.
    // this.list.fuseSearch = new Fuse(this.list.tableData, {
    //   keys: this.sortableColumnNames,
    //   threshold: 0.3
    // });

  },
  created() {
    this.refreshDefaults();
  },

};
